import { Component, Prop, Vue } from 'vue-property-decorator';
import ChatWindow from 'vue-advanced-chat';
import NotificationModule from '@/store/modules/notificacion.module';
import 'vue-advanced-chat/dist/vue-advanced-chat.css';
import {  itiSignalRService, i18n } from '@/iti-core-vue';
import { Notification } from '@/shared/dtos/notificacion';
import NotificacionCard from '@/components/notificacion_card/notificacion_card.vue'
import router from '@/router';

@Component({
    components: {
        ChatWindow,
        NotificacionCard
    },
})
export default class NotificacionInferior extends Vue {
    public notificacion: Notification | null = null;

    public get showNotificacion(): boolean{
        if(this.notificacion){
            return true;
        }
        return false;
    }

    public get currentRoute(): string{
        return this.$route.name? this.$route.name : '';
    }
    public get chatId(): string{
        return this.$route.params.id;
    }

    public created(){
        setTimeout(() => itiSignalRService.listenFor('receiveNotification', this.receiveNotificationHandler), 5000);
    }

    public receiveNotificationHandler(notificacion: Notification){
        if(this.currentRoute === 'ChatUnaSala' && this.chatId === notificacion.idEventSource){
            NotificationModule.markNotificationAsRead(notificacion.id);
            notificacion.isRead = true;
            return;
        }
        this.notificacion = notificacion;
        setTimeout(() => {this.notificacion = null}, 10000);
    }

    public openNotifications(){
        router.push({ name: 'Notificaciones'});
        this.notificacion = null;
    }

    public get mensajeOrigen(): string{
        if(!this.notificacion){
            return i18n.tc('notificaciones.noHayNotificacion');
        }
        if(this.notificacion && this.notificacion.sourceUser){
            var idOrigen: number = this.notificacion.sourceUser;
            if(idOrigen > 0){
                return i18n.tc('notificaciones.mensajeDe') + this.notificacion.sourceUser;
            }
            else{
                switch(idOrigen){
                    case -1: return i18n.tc('notificaciones.sinergias');
                    case -2: return i18n.tc('notificaciones.chat');
                    case -3: return i18n.tc('notificaciones.sistema');
                }
            }
        }
        return i18n.tc('notificaciones.errorOrigen');
    }
}
